<div class="recurso-campanha-filter">
    <div class="recurso-campanha-filter-quick">  
        <div class="recurso-campanha-filter-quick-block recurso-campanha-filter-quick-block-options">
            <div class="recurso-campanha-filter-quick-block-options-multiselect">
                <!-- Áreas -->
                <div class="recurso-campanha-filter-quick-block-options-multiselect-item">
                    <sgt-area-multiselect
                        [(idsAreas)]="filter.idsAreas"
                        (idsAreasChange)="onChangeAreas()"
                        defaultTitle="Áreas"
                        [disabled]="!isFilterInitialized">
                    </sgt-area-multiselect>
                </div> 

                <!-- Situações -->
                <div class="recurso-campanha-filter-quick-block-options-multiselect-item">
                    <sgt-recurso-campanha-situacao-multiselect
                        [(situacoes)]="filter.situacoes"
                        (situacoesChange)="onChangeSituacoes()"
                        defaultTitle="Situações"
                        [disabled]="!isFilterInitialized">
                    </sgt-recurso-campanha-situacao-multiselect>
                </div>
            </div>
        </div>

        <div class="recurso-campanha-filter-quick-block recurso-campanha-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="recurso-campanha-filter-quick-block recurso-campanha-filter-quick-block-options">
            <div class="recurso-campanha-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <!--
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                    -->
                </div>  
            </div>
        </div>
    </div>

    
    <div class="recurso-campanha-filter-collapse" #filterCollapse></div>
</div>

